<template>
    <div>
        <router-link v-if="type==='pendaftaran'" to='/dashboard'><div class="backBtn daftar"><i class="fas fa-caret-left"></i>Kembali ke Dashboard Partai Perindo</div></router-link>
        <a :href="backLink" v-else ><div class="backBtn"><i class="fas fa-caret-left"></i>Kembali ke Website Partai Perindo</div></a>
    </div>
</template>

<script>
export default {
  data () {
    return {
      backUrl: 'fsdfsdfsdfrs'
    }
  },
  props: ['type'],
  computed: {
    backLink () {
      return process.env.VUE_APP_BACK_HOME_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.backBtn{
    color: $red;
    @media only screen and (max-width: 600px) {
        color: $blue;
        font-weight: 600;
        font-size: 12px;
    }
    i{
        margin-right: 1rem;
    }

    &.daftar{
        background-color: $red-bg;
        padding: 10px 25px;
        border-radius: 10px;
        height: 44px;
        display: flex;
        align-items: center;
    }
}
</style>
